import {
  createComponentMapperModel,
  createUDPUiTypeMapper,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import type { GalleryItem } from '@wix/thunderbolt-components-native';
import {
  getHeightPixelValue,
  getWidthPixelValue,
} from '@wix/editor-elements-common-utils';

import type {
  ProGalleryDefinition,
  IProGalleryProps,
  IProGallerySdkData,
} from '../ProGallery.types';

export const props = withCompInfo<
  Omit<IProGalleryProps, 'id'>,
  ProGalleryDefinition,
  { itemsProps: GalleryItem }
>()(
  [
    'compData',
    'compProps',
    'compStylableClass',
    'isQaMode',
    'fullNameCompType',
    'viewMode',
    'compLayout',
    'compSingleLayout',
    'experiments',
    'deviceType',
    'structure',
    'hasResponsiveLayout',
    'isInSeo',
    'isInFirstFold',
    'styleProperties',
  ],
  (data, carmiData) => {
    const {
      compProps,
      compStylableClass,
      isQaMode,
      fullNameCompType,
      deviceType: unmappedDeviceType,
      compLayout,
      compSingleLayout,
      structure: { styleId },
      experiments,
      hasResponsiveLayout,
      isInSeo,
      isInFirstFold,
      styleProperties,
    } = data;

    const width = getWidthPixelValue(compLayout, compSingleLayout);
    const height = getHeightPixelValue(compLayout, compSingleLayout);
    const deviceType =
      {
        Smartphone: 'mobile',
        Tablet: 'tablet',
        Desktop: 'desktop',
        Other: 'desktop',
      }[unmappedDeviceType] || 'desktop';

    const options = {
      ...compProps.options,
      responsive: !!hasResponsiveLayout,
    };

    const newInfoThunderboltExperiment =
      'specs.thunderbolt.proGalleryMasterInfo';
    const positionAbsoluteForFiniteHeightGalleriesExperiment =
      'specs.thunderbolt.positionAbsoluteFiniteHeightGalleries';

    const positionAbsoluteForFiniteHeightGalleries =
      experiments[positionAbsoluteForFiniteHeightGalleriesExperiment];

    let shouldUseNewInfoElements = false;
    if (experiments) {
      shouldUseNewInfoElements =
        experiments[newInfoThunderboltExperiment] === 'new' ||
        experiments[newInfoThunderboltExperiment] === true;
    }
    const isStylableSkin: boolean = styleProperties['st-css'] !== undefined;
    return {
      ...compProps,
      options,
      viewMode: isInSeo ? 'SEO' : 'SITE',
      stylableClassName: compStylableClass,
      deviceType,
      items: carmiData.itemsProps || [],
      isQaMode,
      fullNameCompType,
      styleId,
      editorLayoutHeight: height,
      editorLayoutWidth: width,
      shouldUseNewInfoElements,
      experiments,
      isInSeo,
      isInFirstFold,
      positionAbsoluteForFiniteHeightGalleries,
      isStylableSkin,
    } as any;
  },
);

/**
 * sdkData is sent to the Velo factory (in API) - needed for gallery utils
 */
export const sdkData = withCompInfo<IProGallerySdkData, ProGalleryDefinition>()(
  ['compData'],
  ({ compData }) => {
    return {
      imageDisplayMode: 'fill', // remove once mot used in EE
      dataId: compData.id,
    };
  },
);

export const uiType = createUDPUiTypeMapper('Default', 'ProGallery');

export default createComponentMapperModel({ props, sdkData, uiType });
